import axios from "./axios";
import language from "./language";
async function verify_phone(phone_area_code: string, phone: string) {
    return await axios.post("member/step-1", {
        lang: language(),
        phone_area_code,
        phone,
        type: 1,
      //  recaptcha_token: await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
    });
}

async function verify_email(email: string) {
    return await axios.post("member/step-1", {
        lang: language(),
        email,
        type: 2,
      //  recaptcha_token: await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
    });
}
async function verify_member_no(member_no: string) {
    return axios.post("member/step-1", {
        lang: language(),
        member_no,
        type: 3,
     //   recaptcha_token: await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
    });
}

export { verify_phone, verify_email, verify_member_no };